import React, { useEffect } from 'react';
import { Button } from '@vimily/bonjoro-ui-components';
import { Recording } from '~/types/models';
import { Tab } from './ShareTab';
import { TextInputType } from '~/App/Components/Forms/TextInput';
import { TextInput } from '~/App/Components/Forms';
import { setupClipboard } from '~/Share/Utils';

export type ShareTabContentProps = {
  recording: Recording;
  title: string;
  ctaButtonText: string;
  tab: Tab;
  linkToCopy?: string;
  active: boolean;
};

export default function ShareTabContent({
  title,
  recording,
  ctaButtonText,
  tab,
  linkToCopy,
  active,
}: ShareTabContentProps) {
  useEffect(() => {
    setupClipboard(
      '#copy-link',
      'Link is copied to your clipboard. Share it now.'
    );
  }, []);

  if (!active) {
    return <></>;
  }

  return (
    <>
      <div className='mb-3 font-bold text-base mt-6'> {title} </div>
      <div>
        {(tab === Tab.VideoLink || tab === Tab.EmbedVideo) && (
          <TextInput
            id={tab}
            type={TextInputType.Text}
            value={linkToCopy}
            className='mb-3'
            readOnly
          />
        )}
        {tab === Tab.ThumbAndLink && (
          <div
            id={tab}
            className='border border-solid rounded-md m-auto mb-3 w-11/12 p-5 border-neutral-300'
          >
            <div className='flex justify-left'>
              <a
                href={recording.public_url}
                target='_blank'
                rel='noopener noreferrer'
                className='text-base'
              >
                <img className='w-full' src={recording.media.thumbnail_play} />
                <div className='flex flex-col mt-3 items-start'>
                  <span className='font-bold text-base text-left'>
                    {' '}
                    {recording.name}
                    <br />
                    Watch video
                  </span>
                </div>
              </a>
            </div>
          </div>
        )}
      </div>
      <Button
        className='w-full'
        id='copy-link'
        data-clipboard-target={`#${tab}`}
      >
        {' '}
        {ctaButtonText}{' '}
      </Button>
    </>
  );
}
